import { safeHTML } from '../../../../../utils/safeHTML';
import { useTranslation } from '../../../../../translations';

export default function Text({ text }) {
  const { t } = useTranslation();
  return text && <div className={'button__text custom-button__text'}>{safeHTML(t(text))}</div>;
}
